import { Card } from '../ui/Card';
import { Field } from '../ui/Field';
import { PhiProvider } from '../../contexts/PhiContext';

// Fields rendered on the Member Details tab. All four are PHI per the Data
// Dictionary; the backend nulls them and lists them in phi_masked_fields for
// users without PHI access. <Field> reads the same mask context and renders
// asterisks automatically.
const FIELDS = [
  { name: 'member_name', label: 'Name' },
  { name: 'birth_date', label: 'Birth Date' },
  { name: 'member_id', label: 'Member ID' },
  { name: 'subscriber_id', label: 'Subscriber ID' },
];

function MemberDetailsTab({ identifiers, phiMaskedFields, loading = false, error = null }) {
  if (loading) {
    return (
      <div className="flex-1 flex items-center justify-center px-6 py-5 bg-background">
        <p className="text-sm text-muted-foreground">Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex-1 flex items-center justify-center px-6 py-5 bg-background">
        <p className="text-sm text-destructive">Failed to load member details.</p>
      </div>
    );
  }

  const safeIdentifiers = identifiers || {};
  const maskedFields = phiMaskedFields || [];

  return (
    <div className="flex-1 px-6 py-5 bg-background">
      <Card className="p-5" data-testid="member-details-card">
        <PhiProvider maskedFields={maskedFields}>
          <div className="flex flex-wrap gap-x-10 gap-y-4">
            {FIELDS.map(({ name, label }) => (
              <div key={name} className="flex flex-col">
                <span className="text-sm font-semibold text-foreground">{label}</span>
                <Field name={name} value={safeIdentifiers[name]} className="text-sm text-foreground mt-1" />
              </div>
            ))}
          </div>
        </PhiProvider>
      </Card>
    </div>
  );
}

export { MemberDetailsTab };
